const About = () => {
    return (
            <img src="/assets/img/about.JPG" className="d-block w-100" alt="..." />
    )
    
}

export default About;